var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
export function DinTestInstructions() {
    return (_jsxs("div", __assign({ className: 'flex flex-col gap-1 md:gap-5' }, { children: [_jsxs(Typography, __assign({ className: 'md:text-xl md:text-start' }, { children: ["Listen for ", _jsx("strong", { children: "three numbers" }), " spoken over background noise."] })), _jsxs(Typography, __assign({ className: 'md:text-xl md:text-start' }, { children: ["Enter them in the order you hear and ", _jsx("span", __assign({ className: "font-normal md:font-bold" }, { children: "click" })), " ", _jsx("strong", { children: "Submit." })] })), _jsx(Typography, __assign({ className: 'md:text-xl md:text-start' }, { children: "Repeat for each new set until the test is complete." })), _jsx(Typography, __assign({ className: 'md:text-xl md:text-start' }, { children: "If a number isn't clear, enter your best guess." }))] })));
}
